/**
 * @generated SignedSource<<d7beb0432cf0864f5a12f13d31a5b976>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UserRoleEnum = "ADMIN" | "CLINICAL_SUPERVISOR" | "EMPLOYEE" | "EXTERNAL_CLINICAL_SUPERVISOR" | "IMPERSONATOR" | "MANAGER" | "MENTOR" | "MHP" | "ORGANISATION_ADMIN" | "UNKNOWN";
export type UserStatusEnum = "ACTIVE" | "SUSPENDED";
export type UserSelectorQuery$variables = {
  search?: string | null | undefined;
};
export type UserSelectorQuery$data = {
  readonly users: {
    readonly nodes: ReadonlyArray<{
      readonly email: string;
      readonly id: string;
      readonly name: string;
      readonly role: ReadonlyArray<UserRoleEnum>;
      readonly status: UserStatusEnum;
      readonly surname: string;
    }>;
  };
};
export type UserSelectorQuery = {
  response: UserSelectorQuery$data;
  variables: UserSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 20
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      }
    ],
    "concreteType": "UserConnection",
    "kind": "LinkedField",
    "name": "users",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "surname",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserSelectorQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserSelectorQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9d7b6ee8d0fd05ca882760c4ac26bc3c",
    "id": null,
    "metadata": {},
    "name": "UserSelectorQuery",
    "operationKind": "query",
    "text": "query UserSelectorQuery(\n  $search: String\n) {\n  users(first: 20, search: $search) {\n    nodes {\n      id\n      name\n      surname\n      email\n      status\n      role\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "52f22c99162848876e3e1af272ad12b8";

export default node;
